import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';
import Logo from './Logo';
import Modal from './Modal';
import ContactForm from './ContactForm';
import './Footer.css';

const Footer: React.FC = () => {
  const authenticated = isAuthenticated();
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <Logo size={40} />
              <div className="footer-logo-text">
                <span className="logo-text">Nuru</span>
                <span className="logo-accent">Subs</span>
              </div>
            </div>
            <p className="footer-tagline">
              Swahili transcription and translation made simple
            </p>
          </div>

          <div className="footer-links">
            {authenticated && (
              <div className="footer-column">
                <h4>Product</h4>
                <Link to="/dashboard">Dashboard</Link>
                <Link to="/upload">Upload</Link>
                <Link to="/usage">Usage</Link>
              </div>
            )}

            <div className="footer-column">
              <h4>Company</h4>
              <a href="#about">About</a>
              <button
                onClick={() => setShowContactModal(true)}
                className="footer-link-button"
              >
                Contact Us
              </button>
              <a href="#privacy">Privacy</a>
            </div>

            <div className="footer-column">
              <h4>Office Locations</h4>
              <div className="footer-location">
                <span className="location-icon">📍</span>
                <div>
                  <p className="location-name">Tanzania</p>
                  <p className="location-address">Kinondoni, Dar es Salaam</p>
                </div>
              </div>
              <div className="footer-location">
                <span className="location-icon">📍</span>
                <div>
                  <p className="location-name">South Africa</p>
                  <p className="location-address">11th Avenue, Rivonia</p>
                </div>
              </div>
            </div>

            {authenticated && (
              <div className="footer-column">
                <h4>Resources</h4>
                <Link to="/support">Support</Link>
              </div>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 NuruSubs. Founded in Tanzania 🇹🇿
          </p>
          <div className="footer-social">
            <a href="#twitter" aria-label="Twitter">Twitter</a>
            <a href="#github" aria-label="GitHub">GitHub</a>
            <a href="#linkedin" aria-label="LinkedIn">LinkedIn</a>
          </div>
        </div>
      </div>

      {/* Contact Modal */}
      <Modal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
        title="Contact Us"
      >
        <ContactForm showWhatsApp={false} />
      </Modal>
    </footer>
  );
};

export default Footer;
